import { Enums } from './db_types'
import { GridTable, VirtualTableKind, VirtualTableScope } from './custom_types'

export const VIRTUAL_TABLE_KIND_TO_SCOPE_COLUMN: Record<
  VirtualTableKind,
  'kpis_table_id' | 'custom_record_table_id'
> = {
  kpi: 'kpis_table_id',
  custom_record: 'custom_record_table_id'
}

export const getVirtualTableKindForGridTable = (tableName: GridTable): VirtualTableKind | null => {
  switch (tableName) {
    case 'kpis':
      return 'kpi'
    case 'custom_records':
      return 'custom_record'
    default:
      return null
  }
}

export const getVirtualTableScopeColumn = (scope: VirtualTableScope) =>
  VIRTUAL_TABLE_KIND_TO_SCOPE_COLUMN[scope.kind]

export const getVirtualTableScopeFilter = (scope?: VirtualTableScope | null) =>
  scope
    ? {
        column: getVirtualTableScopeColumn(scope),
        value: scope.tableId
      }
    : null

export const getVirtualTableScopeInsert = (scope?: VirtualTableScope | null) =>
  scope
    ? {
        [getVirtualTableScopeColumn(scope)]: scope.tableId
      }
    : {}

export const getTableConfigVirtualScopeInsert = (scope?: VirtualTableScope | null) => ({
  kpis_table_id: scope?.kind === 'kpi' ? scope.tableId : null,
  custom_record_table_id: scope?.kind === 'custom_record' ? scope.tableId : null
})

export const TABLE_CONFIG_VIRTUAL_SCOPE_ON_CONFLICT =
  'organization_id, table_name, kpis_table_id, custom_record_table_id'

export const getVirtualTableScopeQueryKey = (scope?: VirtualTableScope | null) =>
  scope ? `${scope.kind}:${scope.tableId}` : undefined

export const getVirtualTableScopeStorageKey = (scope?: VirtualTableScope | null) =>
  scope ? `${scope.kind}_${scope.tableId}` : undefined

export const normalizeVirtualTableScope = ({
  tableName,
  kpisTableId,
  virtualTableScope
}: {
  tableName: GridTable
  kpisTableId?: number | null
  virtualTableScope?: VirtualTableScope | null
}): VirtualTableScope | null => {
  if (virtualTableScope) {
    return virtualTableScope
  }

  const kind = getVirtualTableKindForGridTable(tableName)
  if (kind === 'kpi' && kpisTableId) {
    return {
      kind,
      tableId: kpisTableId
    }
  }

  return null
}

export const getPlanSourceForGridTable = (tableName: GridTable): Enums<'plan_source'> | null => {
  switch (tableName) {
    case 'deals':
      return 'deal'
    case 'activities':
      return 'activity'
    case 'invoices':
      return 'invoice'
    case 'kpis':
      return 'kpi'
    case 'line_items':
      return 'line_item'
    case 'custom_records':
      return 'custom_record'
    default:
      return null
  }
}
